import { UNIPROMEL_DOMAIN, OPENLEGAL_DOMAIN, PRIMESALUD_DOMAIN, MENTTUM_DOMAIN } from './domains'
import { OPENSALUD360_SUBDOMAIN } from './subdomains'

export const OPENSALUD_PLATFORM_NAME = 'opensalud'
export const OPENSALUD360_PLATFORM_NAME = 'opensalud360'
export const OPENSALUD_PROFESIONALES_PLATFORM_NAME = 'Opensalud Profesionales'
export const OPENSALUD_PACIENTES_PLATFORM_NAME = 'Opensalud Pacientes'
export const PRIMESALUD_PLATFORM_NAME= 'Opensaludprime'
export const OPENLEGAL_PLATFORM_NAME = 'openlegal'
export const ABOGALITYPRO_PLATFORM_NAME = 'openlegal'
export const UNIPROMEL_PLATFORM_NAME = 'Unipromel'
export const MENTTUM_PLATFORM_NAME = 'Menttum'

export function getPlatformName() {
  return window.location.hostname.includes(UNIPROMEL_DOMAIN) ? UNIPROMEL_PLATFORM_NAME
    : (window.location.hostname.includes(MENTTUM_DOMAIN) ? MENTTUM_PLATFORM_NAME
      : (window.location.hostname.includes(PRIMESALUD_DOMAIN) ? PRIMESALUD_PLATFORM_NAME
        : (window.location.hostname.includes(OPENLEGAL_DOMAIN) ? OPENLEGAL_PLATFORM_NAME
          : (window.location.hostname.includes(`${OPENSALUD360_SUBDOMAIN}.`) ? OPENSALUD360_PLATFORM_NAME
            : OPENSALUD_PLATFORM_NAME))))
}

export const inOpensalud = () => getPlatformName() === OPENSALUD_PLATFORM_NAME
export const inOpensalud360 = () => getPlatformName() === OPENSALUD360_PLATFORM_NAME || getPlatformName() === MENTTUM_PLATFORM_NAME
export const inOpensaludProfesionales = () => getPlatformName() === OPENSALUD_PROFESIONALES_PLATFORM_NAME
export const inOpensaludPacientes = () => getPlatformName() === OPENSALUD_PACIENTES_PLATFORM_NAME
export const inPrimesalud = () => getPlatformName() === PRIMESALUD_PLATFORM_NAME
export const inOpenlegal = () => getPlatformName() === OPENLEGAL_PLATFORM_NAME
export const inAbogalitypro = () => getPlatformName() === ABOGALITYPRO_PLATFORM_NAME
export const inUnipromel = () => getPlatformName() === UNIPROMEL_PLATFORM_NAME
export const inMenttum = () => getPlatformName() === MENTTUM_PLATFORM_NAME


// WEBPACK FOOTER //
// ./src/constants/platformNames.js